import React from "react";

import * as S from "./styles";

export const StepOne = () => {
  return (
    <S.Container>
      <S.Title>
        Bem-vindo(a) ao Simulado Super Med
      </S.Title>
      <S.Text>
        {/*Você poderá realizar o simulado <strong>até às 23h59 de 03/03/2024 </strong><br/>*/}
        <span>Clique no botão abaixo para iniciar agora:</span>
      </S.Text>
    </S.Container>
  );
};
